import React, { useState, useMemo, useEffect } from 'react';
import { Settings, ChevronRight, Save, X, AlertCircle, Copy, Download } from 'lucide-react';
import { useTheme } from '../../contexts/ThemeContext';
import { useToast } from '../../hooks/use-toast';

interface BoniStufe {
  ws: number;
  boni: number;
}

interface BoniTableData {
  agentur: Record<string, BoniStufe[]>;
  hauptagentur: Record<string, BoniStufe[]>;
  generalagenturI: Record<string, BoniStufe[]>;
  generalagenturII: Record<string, BoniStufe[]>;
  bezirksdirektor: Record<string, BoniStufe[]>;
}

export const defaultBonitafeln: BoniTableData = {
  agentur: {
    'KV': [
      { ws: 500, boni: 220 },
      { ws: 800, boni: 320 },
      { ws: 1200, boni: 480 },
      { ws: 1600, boni: 750 },
    ],
    'LV': [
      { ws: 800, boni: 220 },
      { ws: 1200, boni: 320 },
      { ws: 1700, boni: 480 },
      { ws: 2300, boni: 750 },
    ],
    'U': [
      { ws: 450, boni: 530 },
      { ws: 630, boni: 770 },
      { ws: 820, boni: 1200 },
      { ws: 1200, boni: 1700 },
    ],
    'STHRS': [
      { ws: 300, boni: 320 },
      { ws: 600, boni: 470 },
      { ws: 900, boni: 680 },
      { ws: 1200, boni: 1100 },
    ],
    'BS': [
      { ws: 250, boni: 85 },
      { ws: 370, boni: 125 },
      { ws: 480, boni: 190 },
      { ws: 600, boni: 290 },
    ],
  },
  hauptagentur: {
    'KV': [
      { ws: 750, boni: 320 },
      { ws: 1200, boni: 530 },
      { ws: 1700, boni: 840 },
      { ws: 2300, boni: 1300 },
    ],
    'LV': [
      { ws: 1200, boni: 320 },
      { ws: 1900, boni: 530 },
      { ws: 2800, boni: 840 },
      { ws: 3600, boni: 1300 },
    ],
    'U': [
      { ws: 450, boni: 620 },
      { ws: 700, boni: 930 },
      { ws: 950, boni: 1500 },
      { ws: 1200, boni: 2100 },
    ],
    'STHRS': [
      { ws: 450, boni: 370 },
      { ws: 870, boni: 580 },
      { ws: 1300, boni: 840 },
      { ws: 1800, boni: 1300 },
    ],
    'BS': [
      { ws: 500, boni: 100 },
      { ws: 800, boni: 150 },
      { ws: 1100, boni: 250 },
      { ws: 1400, boni: 350 },
    ],
  },
  generalagenturI: {
    'KV': [
      { ws: 1000, boni: 740 },
      { ws: 1900, boni: 1200 },
      { ws: 3000, boni: 1750 },
      { ws: 4500, boni: 2400 },
    ],
    'LV': [
      { ws: 2100, boni: 740 },
      { ws: 3300, boni: 1200 },
      { ws: 4800, boni: 1800 },
      { ws: 6500, boni: 2500 },
    ],
    'U': [
      { ws: 800, boni: 1500 },
      { ws: 1300, boni: 2200 },
      { ws: 1800, boni: 2800 },
      { ws: 2500, boni: 3500 },
    ],
    'STHRS': [
      { ws: 1200, boni: 890 },
      { ws: 2000, boni: 1400 },
      { ws: 3000, boni: 2000 },
      { ws: 4200, boni: 2800 },
    ],
    'BS': [
      { ws: 750, boni: 250 },
      { ws: 1200, boni: 350 },
      { ws: 1700, boni: 450 },
      { ws: 2200, boni: 600 },
    ],
  },
  generalagenturII: {
    'KV': [
      { ws: 1200, boni: 850 },
      { ws: 2200, boni: 1400 },
      { ws: 3500, boni: 2000 },
      { ws: 5000, boni: 2800 },
    ],
    'LV': [
      { ws: 2500, boni: 900 },
      { ws: 3900, boni: 1450 },
      { ws: 5500, boni: 2100 },
      { ws: 7500, boni: 3000 },
    ],
    'U': [
      { ws: 1000, boni: 1700 },
      { ws: 1600, boni: 2500 },
      { ws: 2200, boni: 3200 },
      { ws: 3000, boni: 4000 },
    ],
    'STHRS': [
      { ws: 1500, boni: 1050 },
      { ws: 2400, boni: 1650 },
      { ws: 3500, boni: 2400 },
      { ws: 4800, boni: 3300 },
    ],
    'BS': [
      { ws: 1000, boni: 300 },
      { ws: 1500, boni: 425 },
      { ws: 2000, boni: 575 },
      { ws: 2700, boni: 750 },
    ],
  },
  bezirksdirektor: {
    'KV': [
      { ws: 1500, boni: 1050 },
      { ws: 2700, boni: 1700 },
      { ws: 4200, boni: 2400 },
      { ws: 6000, boni: 3300 },
    ],
    'LV': [
      { ws: 3000, boni: 1100 },
      { ws: 4700, boni: 1800 },
      { ws: 6500, boni: 2600 },
      { ws: 9000, boni: 3700 },
    ],
    'U': [
      { ws: 1200, boni: 2000 },
      { ws: 1950, boni: 3000 },
      { ws: 2700, boni: 3900 },
      { ws: 3700, boni: 4800 },
    ],
    'STHRS': [
      { ws: 1800, boni: 1250 },
      { ws: 2900, boni: 2000 },
      { ws: 4200, boni: 2900 },
      { ws: 5700, boni: 4000 },
    ],
    'BS': [
      { ws: 1200, boni: 375 },
      { ws: 1800, boni: 525 },
      { ws: 2400, boni: 700 },
      { ws: 3200, boni: 925 },
    ],
  },
};

interface BoniTabellenAdminViewProps {
  currentUser?: any;
  onLoadBoniTables?: () => Promise<BoniTableData | null>;
  onSaveBoniTables?: (data: BoniTableData) => Promise<void>;
}

const BoniTabellenAdminView: React.FC<BoniTabellenAdminViewProps> = ({ currentUser, onLoadBoniTables, onSaveBoniTables }) => {
  const { theme } = useTheme();
  const isDark = theme === 'dark' || (theme === 'system' && window.matchMedia('(prefers-color-scheme: dark)').matches);
  
  const [bonitafeln, setBonitafeln] = useState<BoniTableData>(defaultBonitafeln);
  const [loading, setLoading] = useState(!!onLoadBoniTables);
  const [selectedAgentur, setSelectedAgentur] = useState<keyof BoniTableData>('generalagenturII');
  const [selectedSparte, setSelectedSparte] = useState<string>('KV');
  const [editingCell, setEditingCell] = useState<{ stufe: number; field: 'ws' | 'boni' } | null>(null);
  const [editValue, setEditValue] = useState<string>('');
  const [hasChanges, setHasChanges] = useState(false);
  const [showExport, setShowExport] = useState(false);

  useEffect(() => {
    if (!onLoadBoniTables) {
      const stored = localStorage.getItem('bonitafeln_custom');
      if (stored) {
        try {
          const parsed = JSON.parse(stored) as BoniTableData;
          if (parsed && typeof parsed === 'object') setBonitafeln(parsed);
        } catch (_) { /* ignore */ }
      }
      return;
    }
    let cancelled = false;
    onLoadBoniTables().then((data) => {
      if (cancelled) return;
      setLoading(false);
      if (data && typeof data === 'object') setBonitafeln(data);
    }).catch(() => setLoading(false));
    return () => { cancelled = true; };
  }, [onLoadBoniTables]);

  const agenturLabels: Record<keyof BoniTableData, string> = {
    agentur: 'Agentur',
    hauptagentur: 'Hauptagentur',
    generalagenturI: 'Generalagentur I',
    generalagenturII: 'Generalagentur II',
    bezirksdirektor: 'Bezirksdirektor',
  };

  const { toast } = useToast();
  const [pendingReset, setPendingReset] = useState(false);

  const currentStaffeln = bonitafeln[selectedAgentur][selectedSparte] || [];

  const handleCellClick = (stufe: number, field: 'ws' | 'boni') => {
    const value = currentStaffeln[stufe][field];
    setEditingCell({ stufe, field });
    setEditValue(String(value));
  };

  const handleCellChange = (stufe: number, field: 'ws' | 'boni', value: string) => {
    const numValue = parseFloat(value) || 0;
    const newStaffeln = [...currentStaffeln];
    newStaffeln[stufe] = { ...newStaffeln[stufe], [field]: numValue };
    
    setBonitafeln(prev => ({
      ...prev,
      [selectedAgentur]: {
        ...prev[selectedAgentur],
        [selectedSparte]: newStaffeln,
      },
    }));
    
    setHasChanges(true);
  };

  const handleSaveChanges = async () => {
    if (onSaveBoniTables) {
      await onSaveBoniTables(bonitafeln);
      setHasChanges(false);
    } else {
      localStorage.setItem('bonitafeln_custom', JSON.stringify(bonitafeln));
      setHasChanges(false);
      toast({ title: 'Gespeichert', description: 'Bonitafeln lokal gespeichert.' });
    }
  };

  const handleResetToDefault = () => {
    if (!pendingReset) {
      setPendingReset(true);
      return;
    }

    setBonitafeln(defaultBonitafeln);
    setHasChanges(true);
    localStorage.removeItem('bonitafeln_custom');
    setPendingReset(false);
    toast({ title: 'Zurückgesetzt', description: 'Bonitafeln auf Standardwerte gesetzt. Bitte erneut speichern, um in Firestore zu übernehmen.' });
  };

  const handleExport = () => {
    const jsonStr = JSON.stringify(bonitafeln, null, 2);
    const blob = new Blob([jsonStr], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `bonitafeln_${new Date().toISOString().split('T')[0]}.json`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  if (currentUser?.role !== 'admin') {
    return (
      <div className={`rounded-2xl p-8 text-center border ${isDark ? 'glass-card border-white/20' : 'bg-white border-slate-200 shadow-sm'}`}>
        <AlertCircle size={48} className={isDark ? 'text-red-400 mx-auto mb-4' : 'text-red-600 mx-auto mb-4'} />
        <h3 className={`text-xl font-bold mb-2 ${isDark ? 'text-white' : 'text-slate-900'}`}>
          Zugriff verweigert
        </h3>
        <p className={isDark ? 'text-white/70' : 'text-slate-600'}>
          Nur Administratoren können Bonitafeln bearbeiten.
        </p>
      </div>
    );
  }

  if (loading) {
    return (
      <div className={`rounded-2xl p-12 text-center border ${isDark ? 'glass-card border-white/20' : 'bg-white border-slate-200 shadow-sm'}`}>
        <p className={isDark ? 'text-white/80' : 'text-slate-600'}>Boni-Tabellen werden geladen…</p>
      </div>
    );
  }

  return (
    <div className="space-y-6 pb-10 animate-fade-in">
      {/* Header */}
      <div className={`rounded-3xl p-8 backdrop-blur ${isDark ? 'glass-gradient text-white' : 'bg-gradient-to-br from-white via-slate-50 to-slate-100 text-slate-900 border border-slate-200 shadow-lg'}`}>
        <h2 className={`text-4xl font-bold drop-shadow-lg tracking-tight flex items-center gap-3 ${isDark ? 'text-white' : 'text-slate-900'}`}>
          <Settings size={40} className={isDark ? 'text-blue-400' : 'text-blue-600'} />
          Bonitafeln-Verwaltung
        </h2>
        <p className={`${isDark ? 'text-white/80' : 'text-slate-700'} text-lg mt-2`}>Provisionssätze pro Agenturstufe bearbeiten</p>
      </div>

      {/* Controls */}
      <div className={`rounded-2xl p-6 border ${isDark ? 'glass-card border-white/20' : 'bg-white border-slate-200 shadow-sm'}`}>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
          {/* Agentur Auswahl */}
          <div>
            <label className={`block text-sm font-semibold mb-2 ${isDark ? 'text-white/80' : 'text-slate-700'}`}>
              Agenturstufe
            </label>
            <select
              value={selectedAgentur}
              onChange={(e) => {
                setSelectedAgentur(e.target.value as keyof BoniTableData);
                setSelectedSparte('KV');
              }}
              className={`w-full px-4 py-2 rounded-lg border ${isDark ? 'bg-white/10 border-white/20 text-white' : 'bg-slate-50 border-slate-200 text-slate-900'}`}
            >
              {Object.entries(agenturLabels).map(([key, label]) => (
                <option key={key} value={key}>{label}</option>
              ))}
            </select>
          </div>

          {/* Sparte Auswahl */}
          <div>
            <label className={`block text-sm font-semibold mb-2 ${isDark ? 'text-white/80' : 'text-slate-700'}`}>
              Sparte
            </label>
            <select
              value={selectedSparte}
              onChange={(e) => setSelectedSparte(e.target.value)}
              className={`w-full px-4 py-2 rounded-lg border ${isDark ? 'bg-white/10 border-white/20 text-white' : 'bg-slate-50 border-slate-200 text-slate-900'}`}
            >
              {Object.keys(bonitafeln[selectedAgentur]).map(sparte => (
                <option key={sparte} value={sparte}>{sparte}</option>
              ))}
            </select>
          </div>

          {/* Info */}
          <div className={`flex items-end p-4 rounded-lg border ${isDark ? 'bg-white/5 border-white/10' : 'bg-slate-50 border-slate-200'}`}>
            <p className={`text-sm font-semibold ${isDark ? 'text-white/70' : 'text-slate-600'}`}>
              {agenturLabels[selectedAgentur]} - Sparte: {selectedSparte}
            </p>
          </div>
        </div>

        {/* Buttons */}
        <div className="flex gap-2">
          <button
            onClick={handleSaveChanges}
            disabled={!hasChanges}
            className={`flex items-center gap-2 px-4 py-2 rounded-lg font-semibold transition-all ${
              hasChanges
                ? isDark
                  ? 'bg-green-500/20 hover:bg-green-500/30 text-green-300 border border-green-400/50'
                  : 'bg-green-100 hover:bg-green-200 text-green-900 border border-green-300'
                : isDark
                  ? 'bg-white/5 text-white/50 border border-white/10'
                  : 'bg-slate-100 text-slate-400 border border-slate-200'
            }`}
          >
            <Save size={18} /> Speichern
          </button>
          <button
            onClick={handleExport}
            className={`flex items-center gap-2 px-4 py-2 rounded-lg font-semibold transition-all ${isDark ? 'bg-blue-500/20 hover:bg-blue-500/30 text-blue-300 border border-blue-400/50' : 'bg-blue-100 hover:bg-blue-200 text-blue-900 border border-blue-300'}`}
          >
            <Download size={18} /> Export
          </button>
          <button
            onClick={handleResetToDefault}
            className={`flex items-center gap-2 px-4 py-2 rounded-lg font-semibold transition-all ${isDark ? 'bg-red-500/20 hover:bg-red-500/30 text-red-300 border border-red-400/50' : 'bg-red-100 hover:bg-red-200 text-red-900 border border-red-300'}`}
          >
            <X size={18} /> Zurücksetzen
          </button>
        </div>

        {pendingReset && (
          <div className={`mt-3 flex items-center gap-3 rounded-xl border px-3 py-2 text-sm ${isDark ? 'border-red-400/40 bg-red-500/10 text-red-100' : 'border-red-200 bg-red-50 text-red-800'}`}>
            <span className="font-semibold">Alle Bonitafeln auf Standardwerte zurücksetzen?</span>
            <div className="flex gap-2 ml-auto">
              <button
                onClick={handleResetToDefault}
                className={`px-3 py-1 rounded-lg font-semibold ${isDark ? 'bg-red-500/40 hover:bg-red-500/60 text-white' : 'bg-red-600 text-white hover:bg-red-700'}`}
              >
                Ja, zurücksetzen
              </button>
              <button
                onClick={() => setPendingReset(false)}
                className={`px-3 py-1 rounded-lg font-semibold border ${isDark ? 'border-white/20 text-white hover:bg-white/10' : 'border-slate-200 text-slate-700 hover:bg-slate-100'}`}
              >
                Abbrechen
              </button>
            </div>
          </div>
        )}
      </div>

      {/* Bonitafeln Tabelle */}
      <div className={`rounded-2xl p-6 border overflow-x-auto ${isDark ? 'glass-card border-white/20' : 'bg-white border-slate-200 shadow-sm'}`}>
        <h3 className={`text-lg font-bold mb-4 ${isDark ? 'text-white' : 'text-slate-900'}`}>
          {agenturLabels[selectedAgentur]} - {selectedSparte}
        </h3>

        <table className="w-full">
          <thead>
            <tr className={isDark ? 'border-b border-white/20' : 'border-b border-slate-200'}>
              <th className={`text-left px-4 py-3 font-semibold ${isDark ? 'text-white/80' : 'text-slate-700'}`}>
                Stufe
              </th>
              <th className={`text-right px-4 py-3 font-semibold ${isDark ? 'text-white/80' : 'text-slate-700'}`}>
                WS-Schwelle
              </th>
              <th className={`text-right px-4 py-3 font-semibold ${isDark ? 'text-white/80' : 'text-slate-700'}`}>
                Boni (€)
              </th>
                  {/* Zusatzfelder für Quoten */}
                  <div className="flex flex-wrap gap-4 mt-4">
                    {(selectedSparte === 'KV' || selectedSparte === 'LV') && (
                      <div>
                        <label className={`block text-xs font-semibold mb-1 ${isDark ? 'text-white/70' : 'text-slate-700'}`}>Stornoquote (%)</label>
                        <input type="number" min="0" max="100" step="0.01" className={`w-32 px-3 py-2 rounded-lg border ${isDark ? 'bg-white/10 border-white/20 text-white' : 'bg-slate-50 border-slate-200 text-slate-900'}`}/>
                      </div>
                    )}
                    {(selectedSparte === 'STHRS') && (
                      <div>
                        <label className={`block text-xs font-semibold mb-1 ${isDark ? 'text-white/70' : 'text-slate-700'}`}>Schadenquote (%)</label>
                        <input type="number" min="0" max="100" step="0.01" className={`w-32 px-3 py-2 rounded-lg border ${isDark ? 'bg-white/10 border-white/20 text-white' : 'bg-slate-50 border-slate-200 text-slate-900'}`}/>
                      </div>
                    )}
                  </div>
            </tr>
          </thead>
          <tbody>
            {currentStaffeln.map((stufe, idx) => (
              <tr key={idx} className={`border-b ${isDark ? 'border-white/10 hover:bg-white/5' : 'border-slate-100 hover:bg-slate-50'}`}>
                <td className={`px-4 py-3 font-semibold ${isDark ? 'text-amber-300' : 'text-amber-700'}`}>
                  Stufe {idx + 1}
                </td>
                <td className={`text-right px-4 py-3 ${isDark ? 'text-white' : 'text-slate-900'}`}>
                  <input
                    type="number"
                    value={editingCell?.stufe === idx && editingCell?.field === 'ws' ? editValue : stufe.ws}
                    onChange={(e) => {
                      if (editingCell?.stufe === idx && editingCell?.field === 'ws') {
                        setEditValue(e.target.value);
                      }
                      handleCellChange(idx, 'ws', e.target.value);
                    }}
                    onFocus={() => handleCellClick(idx, 'ws')}
                    onBlur={() => setEditingCell(null)}
                    className={`w-full text-right px-3 py-2 rounded-lg border ${isDark ? 'bg-white/10 border-white/20 text-white' : 'bg-slate-50 border-slate-200 text-slate-900'} font-mono focus:outline-none focus:ring-2 focus:ring-blue-400/50`}
                  />
                </td>
                <td className={`text-right px-4 py-3 ${isDark ? 'text-white' : 'text-slate-900'}`}>
                  <input
                    type="number"
                    value={editingCell?.stufe === idx && editingCell?.field === 'boni' ? editValue : stufe.boni}
                    onChange={(e) => {
                      if (editingCell?.stufe === idx && editingCell?.field === 'boni') {
                        setEditValue(e.target.value);
                      }
                      handleCellChange(idx, 'boni', e.target.value);
                    }}
                    onFocus={() => handleCellClick(idx, 'boni')}
                    onBlur={() => setEditingCell(null)}
                    className={`w-full text-right px-3 py-2 rounded-lg border ${isDark ? 'bg-white/10 border-white/20 text-white' : 'bg-slate-50 border-slate-200 text-slate-900'} font-mono focus:outline-none focus:ring-2 focus:ring-green-400/50`}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Info-Box */}
      <div className={`p-4 rounded-xl border ${isDark ? 'bg-blue-500/20 border-blue-400/30' : 'bg-blue-50 border-blue-200'} flex items-start gap-3`}>
        <AlertCircle size={20} className={isDark ? 'text-blue-300 flex-shrink-0 mt-1' : 'text-blue-700 flex-shrink-0 mt-1'} />
        <div>
          <p className={`font-semibold ${isDark ? 'text-blue-200' : 'text-blue-900'}`}>Änderungen speichern</p>
          <p className={`text-sm mt-1 ${isDark ? 'text-blue-300/80' : 'text-blue-800'}`}>
            Alle Änderungen müssen mit "Speichern" bestätigt werden. Die Bonitafeln werden dann im Browser und optional in Firebase synchronisiert.
          </p>
        </div>
      </div>
    </div>
  );
};

export default BoniTabellenAdminView;
